import { mergeAttributes, Node, nodeInputRule } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import Component from "./EmbedBlockData.vue";

export default Node.create({
  name: "embedBlockData",
  group: "block",
  atom: true,
  addAttributes() {
    return {
      path: null,
      selection: null,
      children: null
    };
  },
  parseHTML() {
    return [
      {
        tag: "embed-block-data"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["embed-block-data", mergeAttributes(HTMLAttributes)];
  },
  addInputRules() {
    return [nodeInputRule({ find: /\}>/g, type: this.type })];
  },
  addNodeView() {
    return VueNodeViewRenderer(Component);
  }
});
